module.exports = __webpack_public_path__ + "static/media/pta.26e15baf.pdf";